import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Shell } from './Shell';

let container = document.getElementById('root');

if (!container) {
  container = document.createElement('div');
  container.id = 'root';
  document.body.append(container);
}

createRoot(container).render(
  <StrictMode>
    <Shell />
  </StrictMode>,
);
